import { createFileRoute } from '@tanstack/react-router';

import { ReleaseNotesPage } from '@/features/release-notes';

import { AppLayout } from './-components/app-layout';

export const Route = createFileRoute('/_authenticated/$mallId/release-notes')({
  component: ReleaseNotesRoute,
});

function ReleaseNotesRoute() {
  return (
    <AppLayout pageTitle="업데이트 노트">
      <ReleaseNotesPage />
    </AppLayout>
  );
}
